import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/notice-bj.png'


const _hoisted_1 = { class: "calling" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "您已完成签名，请确保本人签字与投保单签名保持一致", -1)

import { computed, onMounted, reactive, ref, inject, nextTick, getCurrentInstance } from 'vue';
    import tabbar from "src/components/common/tabbar";
    import dayjs from 'dayjs';
    import { TRTCService, QuestionnaireService, AuthService } from 'src/services';
    import { Toast } from 'vant';
    import TRTCCalling from 'trtc-calling-js';
    import { useTRTCStore, useUserInfo } from 'src/store';
    import { useRouter, useRoute } from "vue-router";
    import XhyAutograph from 'src/components/common/autograph';
    import pdfPreview from 'src/components/common/pdf-preview';
    import globalConfig from "../config"
   
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { getUserInfo } = useUserInfo();
    let router = useRouter();
    let route = useRoute();
    let state = reactive({
        showAutograph: false,
        showAutographConfirmOverlay: false,
        base64: "",
        autographOptions:
        {
            penColor: 'black', //笔刷颜色
            minWidth: 2 //最小宽度
        },
    })

    // 当前登入用户信息
    let userInfo = computed(()=>
    {
        return getUserInfo();
    })

    // 确定签名
    const receiveQmValue = async (val) => {
        try
        {
            state.base64 = val.replace("data:image/png;base64,", "");
            state.showAutographConfirmOverlay = true;
        }
        catch(err)
        {
            Toast(err);
        }
        
    }

    // 客户确认签字
    const onAutographConfirm = async (val) => {
        try
        {
            let id = (route.query.id as string);
            let { content: res} = await QuestionnaireService.instance.questionnaireTaskSign({
                taskId: id,
                base64: state.base64
            })

            router.push({name: "questionnaireSuccess", query: {id: res.data}});
        }
        catch(err)
        {
            console.log(err)
            Toast(err);
        }
        
    }



return (_ctx: any,_cache: any) => {
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XhyAutograph), {
      ref: (_value, _refs) => {
        _refs['$autograph'] = _value
      },
      config: _unref(state).autographOptions,
      onReceive: receiveQmValue
    }, null, 8, ["config"]),
    _createVNode(_component_van_overlay, {
      class: "notice-overlay",
      show: _unref(state).showAutographConfirmOverlay,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showAutographConfirmOverlay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", { class: "overlay-btn btn-list" }, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: onAutographConfirm
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})